export default "__VITE_ASSET__Debx2DVx__"